class ClientSystem {
    id: number;
    schoolID: number;
    name: string;
    description: string;
    logoFile: string;
    order: number;
    standard: boolean;
    identificationToken: string;
    authenticationToken: string;
    applicationPath: string;
    applicationLoginPath: string;
    applicationResponsePath: string;
    enforceStrictPaths: boolean;
    certificateExpiry: Date;
    certificateFingerprint: string;
    readSinglePermissions: bigint;
    readMultiPermissions: bigint;
    readAdminPermissions: bigint;
    writeSinglePermissions: bigint;
    writeMultiPermissions: bigint;
    writeAdminPermissions: bigint;
    createdBy: number;
    createdOn: Date;
    editedBy: number;
    editedOn: Date;
    recycledBy: number;
    recycledOn: Date;
    version?: string;

    licenceCount?: number;
    licenceCountDisplay?: string;
    roleUsage?: any[];
    roleAllocations?: any[];
    rawLink?: string;
    link?: string;
    expiryDate?: Date;

    constructor(data?: Partial<ClientSystem>) {
        Object.assign(this, data);

        if (typeof this.createdOn === "string")
            this.createdOn = new Date(this.createdOn);

        if (typeof this.editedOn === "string")
            this.editedOn = new Date(this.editedOn);

        if (typeof this.certificateExpiry === "string")
            this.certificateExpiry = new Date(this.certificateExpiry);
    }
}

export default ClientSystem;